import { render } from "./CookieBar.vue?vue&type=template&id=1948df9c&scoped=true"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"

import "./CookieBar.vue?vue&type=style&index=0&id=1948df9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1948df9c"]])

export default __exports__